export default __webpack_public_path__ + "static/media/sofaking.fc6e1c33.jpg";